import { cva } from "class-variance-authority";

export const alertContainerCva = cva("flex rounded-xl text-sm font-roboto gap-3 px-4 py-3 justify-between border", {
  variants: {
    variant: {
      "primary": "text-primary-600 dark:text-primary-400 border-transparent",
      "secondary": "text-gray-600 dark:text-gray-400 border-transparent",
      "info": "text-blue-600 dark:text-blue-400 border-transparent",
      "success": "text-green-600 dark:text-green-400 border-transparent",
      "danger": "text-red-600 dark:text-red-400 border-transparent",
      "warning": "text-orange-600 dark:text-orange-400 border-transparent",
      "white": "text-gray-600 dark:text-gray-400 border-transparent",
      "gray": "text-gray-600 dark:text-gray-400 border-transparent",
      "text-color": "text-gray-800 dark:text-gray-200 border-transparent",
    },
    background: {
      true: null,
      false: null,
    },
    /** With actions the text, the icon and the buttons centre on each other. */
    align: {
      start: "items-start",
      center: "items-center",
    },
  },
  compoundVariants: [
    {
      variant: "primary",
      background: true,
      class: "text-primary-700 bg-primary-50 border-primary-200 dark:text-primary-200 dark:bg-primary-900/30 dark:border-primary-800",
    },
    {
      variant: "secondary",
      background: true,
      class: "text-gray-700 bg-gray-50 border-gray-200 dark:text-gray-200 dark:bg-gray-900 dark:border-gray-700",
    },
    {
      variant: "info",
      background: true,
      class: "text-blue-700 bg-blue-50 border-blue-200 dark:text-blue-200 dark:bg-blue-900/30 dark:border-blue-800",
    },
    {
      variant: "success",
      background: true,
      class: "text-green-700 bg-green-50 border-green-200 dark:text-green-200 dark:bg-green-900/30 dark:border-green-800",
    },
    {
      variant: "danger",
      background: true,
      class: "text-red-700 bg-red-50 border-red-200 dark:text-red-200 dark:bg-red-900/30 dark:border-red-800",
    },
    {
      variant: "warning",
      background: true,
      class: "text-orange-700 bg-orange-50 border-orange-200 dark:text-orange-200 dark:bg-orange-900/30 dark:border-orange-800",
    },
    {
      variant: ["white", "gray"],
      background: true,
      class: "text-gray-700 bg-gray-50 border-gray-200 dark:text-gray-200 dark:bg-gray-900 dark:border-gray-700",
    },
    {
      variant: "text-color",
      background: true,
      class: "text-gray-700 bg-gray-100 border-gray-200 dark:text-gray-200 dark:bg-gray-800 dark:border-gray-700",
    },
  ],
  defaultVariants: {
    variant: "danger",
    background: true,
    align: "start",
  },
});

export const alertIconCva = cva("flex shrink-0 self-start mt-0.5", {
  variants: {
    variant: {
      "primary": "text-primary-500 dark:text-primary-400",
      "secondary": "text-gray-500 dark:text-gray-400",
      "info": "text-blue-500 dark:text-blue-400",
      "success": "text-green-500 dark:text-green-400",
      "danger": "text-red-500 dark:text-red-400",
      "warning": "text-orange-500 dark:text-orange-400",
      "white": "text-gray-500 dark:text-gray-400",
      "gray": "text-gray-500 dark:text-gray-400",
      "text-color": "text-gray-500 dark:text-gray-400",
    },
    background: {
      true: null,
      false: null,
    },
  },
  compoundVariants: [
    {
      variant: "primary",
      background: true,
      class: "text-primary-500 dark:text-primary-400",
    },
    {
      variant: "secondary",
      background: true,
      class: "text-gray-500 dark:text-gray-400",
    },
    {
      variant: "info",
      background: true,
      class: "text-blue-500 dark:text-blue-400",
    },
    {
      variant: "success",
      background: true,
      class: "text-green-500 dark:text-green-400",
    },
    {
      variant: "danger",
      background: true,
      class: "text-red-500 dark:text-red-400",
    },
    {
      variant: "warning",
      background: true,
      class: "text-orange-500 dark:text-orange-400",
    },
    {
      variant: ["white", "gray"],
      background: true,
      class: "text-gray-500 dark:text-gray-400",
    },
    {
      variant: "text-color",
      background: true,
      class: "text-gray-500 dark:text-gray-400",
    },
  ],
  defaultVariants: {
    variant: "danger",
    background: true,
  },
});

export const alertContentCva = cva("flex flex-col gap-1 flex-1 min-w-0");

export const alertBodyCva = cva("leading-snug", {
  variants: {
    size: {
      small: "text-xs",
      medium: "text-sm",
    },
  },
  defaultVariants: {
    size: "medium",
  },
});

export const alertCloseButtonCva = cva(
  "flex shrink-0 cursor-pointer opacity-60 hover:opacity-100 transition-opacity",
  {
    variants: {
      variant: {
        "primary": "text-primary-600 dark:text-primary-400",
        "secondary": "text-gray-500 dark:text-gray-400",
        "info": "text-blue-600 dark:text-blue-400",
        "success": "text-green-600 dark:text-green-400",
        "danger": "text-red-600 dark:text-red-400",
        "warning": "text-orange-600 dark:text-orange-400",
        "white": "text-gray-500 dark:text-gray-400",
        "gray": "text-gray-500 dark:text-gray-400",
        "text-color": "text-gray-500 dark:text-gray-400",
      },
      background: {
        true: null,
        false: null,
      },
    },
    compoundVariants: [
      {
        variant: "primary",
        background: true,
        class: "text-primary-600 dark:text-primary-400",
      },
      {
        variant: "secondary",
        background: true,
        class: "text-gray-500 dark:text-gray-400",
      },
      {
        variant: "info",
        background: true,
        class: "text-blue-600 dark:text-blue-400",
      },
      {
        variant: "success",
        background: true,
        class: "text-green-600 dark:text-green-400",
      },
      {
        variant: "danger",
        background: true,
        class: "text-red-600 dark:text-red-400",
      },
      {
        variant: "warning",
        background: true,
        class: "text-orange-600 dark:text-orange-400",
      },
      {
        variant: ["white", "gray"],
        background: true,
        class: "text-gray-500 dark:text-gray-400",
      },
      {
        variant: "text-color",
        background: true,
        class: "text-gray-500 dark:text-gray-400",
      },
    ],
    defaultVariants: {
      variant: "danger",
      background: true,
    },
  },
);
